export default __webpack_public_path__ + "static/media/SpheroEdu.ba437308.png";